import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ReactGA from 'react-ga4';

//Components
import {
    AssessmentNav,
    AssessmentResult,
    CalculatingAssessment,
    InsomniaReferral,
    Question,
    SaveApneaAssessment,
} from '../../components/Assessment';

import { useAssessmentContext } from '../../providers';
import { AnythingElse } from '../../components/Assessment/Question/QuestionTypes';

function Assessment() {
    const { assessmentStep, currentQuestionIndex, questions, setPartner } = useAssessmentContext();

    //Handle partner from URL params during assessment so that refreshing screen does not lose this information
    const [searchParams] = useSearchParams();
    const partnerId = useMemo(() => searchParams.get('partnerId'), [searchParams]);
    const partnerType = useMemo(() => searchParams.get('partnerType'), [searchParams]);

    useEffect(() => {
        if (partnerId) setPartner({ partnerId: +partnerId, partnerType: partnerType ?? 'OTHER' });
        // eslint-disable-next-line
    }, [partnerId, partnerType]);

    //Capture starting and viewing of assessment
    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' });

        if (currentQuestionIndex === 0) {
            ReactGA.event({
                category: 'User',
                action: 'Started assessment',
            });
        } else {
            if (questions[currentQuestionIndex]?.answerKey) {
                ReactGA.event({
                    category: 'User',
                    action: 'Viewed a question',
                    label: questions[currentQuestionIndex].answerKey,
                });
            }
        }
        //eslint-disable-next-line
    }, [currentQuestionIndex]);

    return (
        <div className="container">
            <AssessmentNav />

            <AnimatePresence mode="wait">
                {assessmentStep === 'questions' && (
                    <Question key={`question-${currentQuestionIndex}`} />
                )}
                {assessmentStep === 'insomnia' && <InsomniaReferral />}
                {assessmentStep === 'anythingElse' && <AnythingElse />}
                {assessmentStep === 'calculating' && <CalculatingAssessment />}
                {assessmentStep === 'result' && <AssessmentResult />}
                {assessmentStep === 'create-account' && <SaveApneaAssessment />}
            </AnimatePresence>
        </div>
    );
}

export default Assessment;
